import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { ExportGitService } from './export-git.service';

@Injectable({ providedIn: 'root' })
export class ExportGitFactoryService extends AbstractGitFactoryService<ExportGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: ExportGitService,
    });
  }
}
